// extracted by mini-css-extract-plugin
module.exports = {"root":"IconRemove_root__1XmSc"};